export default __webpack_public_path__ + "static/media/power-button.bea3d368.svg";